import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";

export class CreateV2VisitEndpoint implements ICreateV2VisitEndpoint
{
    public async execute(nodeId: number, visit: ICreateV2Visit): Promise<ICreateV2VisitResponse>
    {
        try
        {
            const response: AxiosResponse<ICreateV2VisitResponse> = await axios.post(`${apis.allApiv2}${nodeId}/Visits?disableExtUpdate=${visit.Disable_Ext_Update}`, visit);
            return response.data;
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface ICreateV2VisitEndpoint
{
    execute(nodeId: number, visit: ICreateV2Visit): Promise<ICreateV2VisitResponse>;
}

export interface ICreateV2Visit
{
    Visitor_First_Name: string;
    Visitor_Last_Name: string;
    Visitor_Email: string;
    Visitor_Company: string;
    Visit_Host_Name: string;
    Visit_Host_Email: string;
    Visit_Start_Date: string;
    Visit_End_Date: string;
    Visit_Approval_Comments: string;
    Visitor_Dietary_Pref: number;
    Visit_Pacs_Id: string;
    Visit_Save_Info: number;
    Space_Id: string;
    Space_Name: string;
    Disable_Ext_Update: boolean;
  }

  export interface ICreateV2VisitResponse
  {
    Visit_CheckIn_Time: string;
    Visit_CheckOut_Time: string;
    Visit_IsEarly_Checkin: number;
    Visit_IsLate_Checkin: number;
    Visit_Scheduled_Duration: number;
    Visit_Actual_Duration: number;
    Space_Id: string;
    Booking_Id: string;
    Booking_Star: string;
    Booking_End: string;
    Node_Id: number;
    Space_Name: string;
    Visit_Id: string;
    Visitor_First_Name: string;
    Visitor_Last_Name: string;
    Visitor_Email: string;
    Visitor_Company: string;
    Visit_Host_Name: string;
    Visit_Host_Email: string;
    Visit_Start_Date: string;
    Visit_End_Date: string;
    Visit_IsCheckedIn: number;
    Visit_IsApproved: number;
    Visit_IsCancelled: number;
    Visit_IsNoShow: number;
    Visit_IsCheckedOut: number;
    Visit_Approval_Comments: string;
    Visitor_Dietary_Pref: number;
    Visit_Status: string;
    Visit_IsDenied: number;
    Visit_Save_Info: number;
    Booking_Name: string;
    Meta_Ext_Visit_Id: string;
    Visit_Approve_Time: string;
    Visit_Deny_Time: string;
    Visit_Pacs_Id: number;
    CheckInWorkflow: string;
  }